import React, { useState, useEffect } from "react";

const AttendanceTable = ({ attendanceData, loading, attendanceStatus }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [attendanceData]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = attendanceData.slice(
    indexOfFirstUser,
    indexOfFirstUser + usersPerPage
  );

  if (loading) {
    return <div className="spinner" style={{ marginTop: "50%" }}></div>;
  }

  if (attendanceData.length === 0) {
    return (
      <div className="attendance-status">
        <img src={`${process.env.PUBLIC_URL}/images/clock-in-img.png`} alt="Clock in" />
        <p>{attendanceStatus}</p>
      </div>
    );
  }

  const totalPages = Math.ceil(attendanceData.length / usersPerPage);

  return (
    <div className="attendance-table">
      <div className="attendance-table-container">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Clock-In</th>
              <th>Time Spent</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((entry, index) => (
              <tr key={index}>
                <td>{entry.user_name}</td>
                <td>
                  {new Date(entry.clock_in).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </td>
                <td>{entry.hours_spent || "---"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination">
          <div className="pagination-info">
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              className="cal-page-btn"
            >
              Previous
            </button>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="cal-page-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceTable;
